import { StateDeclaration, StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { EnumService } from '../../../../app.common/modules/common/services/enum.service';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { IAuthRouteService } from '../../../../app.common/modules/routes/models';
import { AccountService } from '../../account/account.service';
import { JispPayAccountService } from '../../account/jispPayAccount.service';

export class AuthService implements IAuthRouteService {
    public static $inject = [
        '$state',
        '$q',
        'accountService',
        'jispPayAccountService',
        'enumService',
        'notificationService',
        '$translate',
        '$window'
    ];
    public loginState = 'account.login';
    public storesState = 'app.shops';
    private redirectStates: string[] = [
        'jisppay.loyalty', 'jisppay.sessionsList', 'jisppay.orders', 'jisppay.select-store', 'jisppay.default', 'jisppay.delivery'
    ];

    constructor(
        private $state: StateService,
        private $q: ng.IQService,
        private accountService: AccountService,
        private jispPayAccountService: JispPayAccountService,
        private enumService: EnumService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private $window: ng.IWindowService
    ) { }

    public async checkAccess(cancel: () => void, toState: StateDeclaration)  {
        return new Promise(async (resolve) => {
            /* Redirect state */
            if (this.redirectStates.indexOf(toState.name) > -1) {
                this.$window.location.href = toState.url;
                resolve();
                return;
            }

            // handling of public routes
            if (toState.data && !toState.data.auth) {
                resolve();
                return;
            }

            /* Redirect from nfrn */
            if (toState.name.startsWith('nfrn')) {
                resolve();
                return;
            }

            const userData = this.accountService.userData;

            /* if retailer or store maanger logged and requested login page */
            if (userData.isAuth && toState.name === 'account.login') {
                this.$state.go('home.screen');
                resolve();
                return;
            }

            if (this.accountService.isRetailerTokenPresents()) { /* Retailer token is stored in localstorage */
                /* Process auth access for retailer */
                if (toState.data && toState.data.auth !== undefined) {
                    /* Route for auth user and user is not authenticated */
                    if (toState.data.auth && !userData.isAuth) {
                        if (cancel) {
                            cancel();
                        }
                        /* Cleanup retailer token and data */
                        console.log('Not auth');
                        this.accountService.clearAuthData();
                        this.$state.go(this.loginState);
                        resolve();
                        return;
                    } else if (toState.data.auth && userData.isAuth) { /* Route for auth user and user is authenticated */
                        /* If authenticated profile filled */
                        if (userData.email) {
                            this.retailerAccess(toState.data.onlyRetailer, userData.permission, cancel);
                            resolve();
                            return;
                        } else { /* authenticated user profile not filled */
                            this.notificationService.showWaitingMessage();
                            try {
                                await this.accountService.getProfile();
                                this.notificationService.clearAll();
                                this.retailerAccess(toState.data.onlyRetailer, userData.permission, cancel);
                                resolve();
                                return;
                            } catch (error) { /* Error geting authenticated user profile (incorrect token or token rotted )*/
                                if (cancel) {
                                    cancel();
                                }
                                this.notificationService.showErrorMessage({
                                    title: this.$translate.instant('error'),
                                    body: this.$translate.instant('failed_to_get_profile')
                                });
                                /* Cleanup retailer token and data */
                                console.log('Error');
                                this.accountService.clearAuthData();
                                this.$state.go(this.loginState);
                                resolve();
                                return;
                            }
                        }
                    }
                } else {
                    resolve();
                    return;
                }
            } else if (this.jispPayAccountService.isSellerTokenPresents()) { /* Seller token is stored in localstorage */
                if (cancel) {
                    cancel();
                }
                this.jispPayAccountService.navigateToDefault();
                resolve();
                return;
            } else { /* No token presents in localhost */
                console.log('No tokens');
                this.accountService.clearAuthData();
                this.$state.go(this.loginState);
                resolve();
                return;
            }
        });
    }

    private retailerAccess(isOnlyRatailer: boolean, permission: number, cancel: () => void) {
        if (!isOnlyRatailer || (isOnlyRatailer === true && permission && permission === this.enumService.RetailerPermission.Retailer)) {
            return;
        } else {
            if (cancel) {
                cancel();
            }
            this.$state.go(this.storesState);
        }
    }
}

angular.module('app.common').service('authService', AuthService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/services/auth.service.ts